import { getHash } from '../../utils/getHash';
import { sortOccupancyData } from '../../utils/sortOccupancyData';
import { OccupancyData } from '../resourceOrder/occupancyTypes';

interface GetServicePricingHashOptions {
    currencyCode: string | undefined;
    endUtc: string | undefined;
    enterpriseId: string;
    occupancyData: Array<OccupancyData>;
    serviceId: string;
    startUtc: string | undefined;
    voucherCode?: string;
}

export const getServicePricingHash = ({
    currencyCode,
    endUtc,
    enterpriseId,
    occupancyData,
    serviceId,
    startUtc,
    voucherCode,
}: GetServicePricingHashOptions) =>
    getHash({
        currencyCode,
        endUtc,
        enterpriseId,
        occupancyData: sortOccupancyData(occupancyData),
        serviceId,
        startUtc,
        voucherCode,
    });
